import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { FormField } from '@cp/ds/src/components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormModel, useTimeSelectItems } from '../../../model';
import { TimeProps } from './model';

export const Time: React.FC<TimeProps> = () => {
  const form = useFormContext<FormModel>();

  const handleResetDateTimeFields = React.useCallback(() => {
    form.setValue('date', null);
    form.setValue('startedAt', null);
    form.setValue('endedAt', null);
  }, [form]);

  // Reason to use 'useWatch' and 'getValues' together:
  // https://github.com/react-hook-form/react-hook-form/issues/2738
  useWatch<FormModel, 'date'>({ name: 'date' });
  const date = form.getValues('date');

  // Reason to use 'useWatch' and 'getValues' together:
  // https://github.com/react-hook-form/react-hook-form/issues/2738
  useWatch<FormModel, 'startedAt'>({ name: 'startedAt' });
  const startedAt = form.getValues('startedAt');

  const { startedAtItems, endedAtItems } = useTimeSelectItems({ date, startedAt, onResetDateTimeFields: handleResetDateTimeFields });

  return (
    <Stack direction="row" gap={2.5} sx={{ ['& > *']: { flex: '1 1 50%' } }}>
      <FormField
        disabled={!startedAtItems.length}
        fieldContainerProps={{ sx: { width: 1 } }}
        fieldLabel="Время начала"
        items={startedAtItems}
        name="startedAt"
        placeholder="__:__"
        sx={{ width: 1 }}
        type="select"
      />
      <FormField
        disabled={!endedAtItems.length}
        fieldContainerProps={{ sx: { width: 1 } }}
        fieldLabel="Время окончания"
        items={endedAtItems}
        name="endedAt"
        placeholder="__:__"
        sx={{ width: 1 }}
        type="select"
      />
    </Stack>
  );
};
